let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4jkd5")).then(() => parcelRequire('2i89M'));